export const homePortsLocalStorageKey = 'homeports';
export const resourcesWidgetLocalStorageKey = 'widgetResources';
